import axios from 'axios';
import normalize from 'Utils/normalizer';
import { map, omitBy, isEmpty, isNil, omit } from 'lodash';
import { apiURL } from '../helpers';
import { errorHandler } from '../utils';
import {isNull} from 'lodash';

type Pagination = {
  offset: number,
  limit: number
}

type Filters = {
  _id?: string,
  inventoryID?: string,
  isEcomProduct?: string,
  orgID?: string,
  code?: string,
  name?: string,
  active?: boolean,
  type?: string,
  displaySite?: string
  sourceSite?: string,
}

interface Sorting {
  sortBy: string,
  mode: "ASC" | "DESC"
}

export const fetchProductList = async (filters: Filters, pagination?: Pagination, sorting?:Sorting) => {

  const url = apiURL('/ecom/product/list');
  filters.displaySite = process.env.ACCOUNT_TYPE;
  filters.sourceSite = process.env.ACCOUNT_TYPE;
  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: omitBy({ filters: filters, pagination, sorting }, isNil)
    })

    return !isEmpty(response.data.products) ?
      map(response.data.products, inventory => {
        return normalize.response.inventory(inventory)
      }) : [];
  }
  catch(err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchProductList(filters, pagination);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack }};
    }
    else {
      console.log(err.message)
      return { error: { message: err.message }};
    }
  }
}

type fetchCategoryListFilters = {
  orgID?: string,
  name?: string,
  active?: boolean,
  level?: Array<any>,
  sourceSite?: string,
  parent?: string,
  totalCount?: boolean
}

export const fetchCategoryList = async (filters: fetchCategoryListFilters, pagination?: Pagination) => {
  const url = apiURL('/master_data/product_category/list');

  filters = {
    ...filters,
    sourceSite: process.env.ACCOUNT_TYPE,
  }

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: omitBy({ filters: filters }, isNil)
    })
    return !isEmpty(response.data.product_categories) ? response.data.product_categories: [];

  }
  catch(err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchCategoryList(filters, pagination);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack }};
    }
    else {
      console.log(err.message)
      return { error: { message: err.message }};
    }
  }
}

export const fetchProductData = async (filters: Filters, pagination?: Pagination) => {
  const url = apiURL('/ecom/product/fetch');

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: omitBy({ ...filters,
        sourceSite: process.env.ACCOUNT_TYPE,
      }, isNil)
    })

    return  normalize.response.inventory(response.data.product, response.data.vouchers);
  }
  catch(err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchProductData(filters, pagination);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack }};
    }
    else {
      console.log(err.message)
      return { error: { message: err.message }};
    }
  }
}

interface FetchProductSectionListPayload {
  filters: {
    isLandingPage?: boolean;
    orgID?: string;
    sourceSite?: "P2U" | "DEM";
    type: string;
    totalCount?: boolean;
  };
  pagination?: {
    offset: number;
    limit: number;
  };
  sorting?: {
    sortBy: string;
    mode: "ASC" | "DESC"
  }
}

export const fetchProductSectionList = async ({ filters, pagination, sorting }: FetchProductSectionListPayload) => {
  const url = apiURL('/product_section/list');

  const initFilters = {
    sourceSite: process.env.ACCOUNT_TYPE
  };

  if (isEmpty(sorting)) {
    sorting = {
      sortBy: 'position',
      mode: 'ASC',
    }
  }

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: omitBy({ filters: { ...initFilters, ...filters }, pagination, sorting }, isNil)
    })

    return !isEmpty(response.data.product_sections) ?
      map(response.data.product_sections[0].inventory_data, item => {
        const supplierData = response.data.product_sections[0].org_data.find((org) => {
          if (org._id == item.orgID) {
           return org
          }
        })
        const inventory = !isEmpty(item) ? {...item, org_data: supplierData} : {};
        return normalize.response.inventory(inventory)
      }) : [];

  }
  catch(err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchProductSectionList({ filters, pagination, sorting });
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack }};
    }
    else {
      console.log(err.message)
      return { error: { message: err.message }};
    }
  }
}
